module.exports = __webpack_public_path__ + "img/set_theme_14.e432af51.png";